import { render, staticRenderFns } from "./MoshikomiFile.vue?vue&type=template&id=569ffdb6&scoped=true&"
import script from "./MoshikomiFile.vue?vue&type=script&lang=js&"
export * from "./MoshikomiFile.vue?vue&type=script&lang=js&"
import style0 from "./MoshikomiFile.vue?vue&type=style&index=0&id=569ffdb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569ffdb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
